import { AbstractControl, ValidatorFn } from '@angular/forms';

export function tipoArquivoValidator(allowedExtensions: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const file = control.value;

    if (file && file.name) {
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some(ext => fileName.endsWith(ext.toLowerCase()));

      if (!isValid) {
        return { invalidExtension: { allowed: allowedExtensions } };
      }
    }

    return null;
  };
}
